export const DocumentTitleCategory = {
  AttachmentCategory: {
    value: 1215,
  },
  AttachmentTitle: {
    value: 1216,
  },
};
